if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      getMainSwiper() {
        return this.mainSwiper || this.querySelector('.yamaga-product-gallery__main')?.swiper || null;
      }

      getMainSlideSelector() {
        if (this.querySelector('.yamaga-product-gallery__main')) {
          return '.yamaga-product-gallery__main .swiper-slide[data-media-id]';
        }

        if (this.elements.viewer.querySelector('.swiper-wrapper')) {
          return '.swiper-slide[data-media-id]';
        }

        return '.product__media-item[data-media-id]';
      }

      getMainSlides() {
        return this.elements.viewer.querySelectorAll(this.getMainSlideSelector());
      }

      findMainSlideByMediaId(mediaId) {
        return Array.from(this.getMainSlides()).find((slide) => slide.dataset.mediaId === mediaId);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.findMainSlideByMediaId(mediaId) || this.getMainSlides()[0];
        if (!activeMedia) {
          return;
        }
        const mainSwiper = this.getMainSwiper();
        const mainSlides = this.getMainSlides();
        if (!mainSwiper) {
          mainSlides.forEach((element) => {
            element.classList.remove('is-active');
          });
          activeMedia?.classList?.add('is-active');
        } else {
          mainSlides.forEach((element) => {
            element.classList.add('is-active');
            element.classList.toggle(
              'yamaga-product-gallery__slide--current',
              element === activeMedia
            );
          });
        }

        if (prepend) {
          const slideContainer =
            activeMedia.closest('.swiper-wrapper') || activeMedia.parentElement;
          if (slideContainer && slideContainer.firstChild !== activeMedia) {
            slideContainer.prepend(activeMedia);
          }

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            const thumbContainer =
              activeThumbnail?.closest('.swiper-wrapper') || activeThumbnail?.parentElement;
            if (activeThumbnail && thumbContainer && thumbContainer.firstChild !== activeThumbnail) {
              thumbContainer.prepend(activeThumbnail);
            }
          }

          if (this.getMainSwiper()) {
            this.getMainSwiper().update();
          }
          if (this.thumbsSwiper) {
            this.thumbsSwiper.update();
          }
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          const swiper = this.getMainSwiper();
          if (swiper) {
            swiper.update();
            const index = Array.from(this.getMainSlides()).indexOf(activeMedia);
            if (index >= 0) {
              swiper.slideTo(index, prepend ? 0 : 350);
            }
          } else if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);

        const thumbSlide = thumbnail.classList?.contains('swiper-slide')
          ? thumbnail
          : thumbnail.closest('.swiper-slide');

        if (this.thumbsSwiper && thumbSlide) {
          const thumbSlides = this.elements.thumbnails.querySelectorAll('.swiper-slide');
          const index = Array.from(thumbSlides).indexOf(thumbSlide);
          if (index >= 0) {
            this.thumbsSwiper.slideTo(index, 300);
          }
          return;
        }

        if (this.elements.thumbnails.isSlideVisible?.(thumbnail, 10)) return;

        this.elements.thumbnails.slider?.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
